import { render, staticRenderFns } from "./UiImgLoader.vue?vue&type=template&id=b5a8a12e&scoped=true&"
import script from "./UiImgLoader.vue?vue&type=script&lang=js&"
export * from "./UiImgLoader.vue?vue&type=script&lang=js&"
import style0 from "./UiImgLoader.vue?vue&type=style&index=0&id=b5a8a12e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a8a12e",
  null
  
)

export default component.exports